import { css } from '@emotion/react'
import { colors, HFlow, Text, Theme, useTheme } from 'bold-ui'
import { resolveName, usePecField } from 'components/form'
import { RadioFieldContainer } from 'components/form/field/RadioFieldContainer'
import { AcompanhamentoCondicaoSaudeTematicaEnum } from 'graphql/types.generated'
import { Meta } from 'util/metaPath'
import { PecIcon, PecIconProps } from 'view/atendimentos/list/PecIcon'

interface ListaTematicaRadioButtonProps {
  name: Meta<AcompanhamentoCondicaoSaudeTematicaEnum>
  label: string
  value: AcompanhamentoCondicaoSaudeTematicaEnum
  icon: PecIconProps['icon']
  onClick: (listaTematica: AcompanhamentoCondicaoSaudeTematicaEnum) => void
}

export function ListaTematicaRadioButton(props: Readonly<ListaTematicaRadioButtonProps>) {
  const { name, label, value, icon, onClick } = props

  const theme = useTheme()
  const styles = createStyles(theme)
  const { input } = usePecField({
    name: resolveName(name),
    onChange: () => onClick(value),
  })

  return (
    <RadioFieldContainer name={name} value={value} onChange={input.onChange} style={styles.button}>
      <HFlow justifyContent='space-between' alignItems='center' style={styles.child}>
        <Text fontWeight='bold' fontSize={0.875}>
          {label}
        </Text>
        <PecIcon size={1.5} icon={icon} color={colors.gray.c40} />
      </HFlow>
    </RadioFieldContainer>
  )
}

const createStyles = (theme: Theme) => ({
  button: css`
    border: solid 1px ${theme.pallete.gray.c60};
    border-radius: 2px;
    padding: 0.4rem;
  `,
  child: css`
    width: 13.625rem;
    margin-left: -0.5rem;
  `,
})
